import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'PlayerInfo',
  values: {
    playerInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '44px',
          padding: '2px 0',
          boxSizing: 'border-box',
          flexGrow: '0',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      },
    },
    playerNameHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    teamNameHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
